/**
 * Created by sagardesai on 10/07/18.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions/index';
import * as _ from 'lodash'
import ContentLoader from "react-content-loader"

import {getData, LOGIN} from "../../util/storage";
import {getSearchQuery, isEmpty} from "../../util/utility";
import MessageUser from "../../components/MessageUser"
//image
import icon_favourite_active from "../../assets/images/icon-heart-active@2x.png"
import onlineCircle from '../../assets/images/icon-circle-blue@2x.png';

class Favourites extends Component {

    constructor(props) {
        super(props);
        this.state = {
            favouritesList: [],
            userDataForMessage:null,
            isVisible:false,
            messageAllData: "favourites"

        }
    }

    componentDidMount() {
        getData(LOGIN)
            .then((data) => {
                if(!isEmpty(data)){
                    this.props.getFavouritesList(data.token, data.api_token, getSearchQuery(), "")
                }
            })


    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        //check if we have user information

        if (nextProps.broadcaster_favourites.hasOwnProperty("performSearch") &&
            nextProps.broadcaster_favourites.performSearch) {
            this.props.setSearchFavouritesState(false)
            getData(LOGIN)
                .then((data) => {
                    if(!isEmpty(data)){
                        this.props.getFavouritesList(data.token, data.api_token, getSearchQuery(), "")
                    }
                })

        }

        if (nextProps.hasOwnProperty("broadcaster_favourites") &&
            nextProps.broadcaster_favourites.hasOwnProperty("favouritesList") &&
            nextProps.broadcaster_favourites.favouritesList &&
            nextProps.broadcaster_favourites.favouritesList !== null  &&
            nextProps.broadcaster_favourites.favouritesList.data.hasOwnProperty("data") &&
            nextProps.broadcaster_favourites.favouritesList.data.data !== null) {
            this.setState({
                favouritesList: nextProps.broadcaster_favourites.favouritesList.data.data
            })
            this.props.resetFavouritesList()

        }

        if (nextProps.hasOwnProperty("broadcaster_favourites") &&
            nextProps.broadcaster_favourites.hasOwnProperty("favourite_unfavourite_data") &&
            nextProps.broadcaster_favourites.favourite_unfavourite_data != null &&
            nextProps.broadcaster_favourites.favourite_unfavourite_data.hasOwnProperty("success") &&
            !nextProps.broadcaster_favourites.isFetching && nextProps.broadcaster_favourites.isSuccess) {


            this.props.resetFavouritesUnFavouriteData()
            getData(LOGIN)
                .then((data) => {
                    if(!isEmpty(data)){
                        this.props.getFavouritesList(data.token, data.api_token, getSearchQuery(), "")
                    }
                })
        }

        if (nextProps.hasOwnProperty("broadcaster_send_message") &&
            nextProps.broadcaster_send_message.hasOwnProperty("messageModal") &&
            nextProps.broadcaster_send_message.messageModal !== null &&
            nextProps.broadcaster_send_message.messageModal !== undefined) {
            // this.setState({data});
            this.setState({
                isVisible : true,
                userDataForMessage: nextProps.broadcaster_send_message.messageModal.userData,
                messageAllData: nextProps.broadcaster_send_message.messageModal.messageAllData
            })
            this.props.hideMessageModal()
        }
    }

    sortByOptionSelected = () => {
        var x = document.getElementById("inputGroupSelect01").value;

        getData(LOGIN)
            .then((data) => {
                if(!isEmpty(data)){
                    const filter = x === "2" ? "online" : x === "3" ? "offline" : ""
                    this.props.getFavouritesList(data.token, data.api_token, "", filter)
                }
            })
    }

    clickedOnUnFavourite = (user) => () => {

        getData(LOGIN)
            .then((data) => {
                if(!isEmpty(data)){
                    this.props.unFavouriteViewer(data.token, data.api_token, user.user_id)
                }
            })

    }


    clickedOnIndividualMessage = (userData) => () => {
        this.setState({
            isVisible : true,
            userDataForMessage: userData
        })
    }

    clickedOnMessageAll = () => {
        this.setState({
            isVisible : true,
            userDataForMessage: null,
            messageAllData: "favourites"
        })
    }

    toggleVisibilityOfMessage = () => {
        this.setState({ isVisible: !this.state.isVisible})
    }

    render() {

        return (
            <div>
                <main role="main" className="">
                    <div className="broadcast-container-parent row">
                        <div className="broadcast-container other-middle-container">
                            <div className="title-container">

                                <div>
                                    <h4>Favourites
                                        {this.state.favouritesList && this.state.favouritesList.length > 0 && <span> ({this.state.favouritesList.length})</span> }
                                    </h4>
                                </div>

                                {this.state.favouritesList && this.state.favouritesList.length > 0 && <div>
                                    <span>Sort by</span>
                                    <select className="custom-select" id="inputGroupSelect01" onChange={this.sortByOptionSelected}>
                                        <option defaultValue="1">All</option>
                                        <option value="2">Online</option>
                                        <option value="3">Offline</option>
                                    </select>
                                    <button className="btn btn-outline-primary" onClick={this.clickedOnMessageAll} id="showMessageAll">Announcement</button>
                                </div>}
                            </div>
                            {this.props.broadcaster_favourites.isFetching && this.state.favouritesList && this.state.favouritesList.length === 0 &&
                            <ContentLoader
                                height={240}
                                speed={1}
                                primaryColor="#f3f3f3"
                                secondaryColor="#ecebeb">

                                <rect x="10" y="20" rx="4" ry="4" width="70" height="40"/>
                                <rect x="10" y="65" rx="4" ry="4" width="70" height="5"/>
                                <rect x="10" y="75" rx="4" ry="4" width="70" height="5"/>

                                <rect x="90" y="20" rx="4" ry="4" width="70" height="40"/>
                                <rect x="90" y="65" rx="4" ry="4" width="70" height="5"/>
                                <rect x="90" y="75" rx="4" ry="4" width="70" height="5"/>

                                <rect x="170" y="20" rx="4" ry="4" width="70" height="40"/>
                                <rect x="170" y="65" rx="4" ry="4" width="70" height="5"/>
                                <rect x="170" y="75" rx="4" ry="4" width="70" height="5"/>

                            </ContentLoader>
                            }
                            <div className="row">

                                {
                                    this.state.favouritesList && this.state.favouritesList.length > 0 && _.map(this.state.favouritesList, (data) => {

                                        return <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4"  key={data.user_id}>

                                            <div className="broadcast-wrapper followers-wrapper">
                                                <div className="followers-img">
                                                    <img src={data.profile_pic} alt="followers"/>
                                                </div>
                                                <div style={{cursor:'pointer'}} onClick={this.clickedOnUnFavourite(data)} className="followers-icon">
                                                    <img src={icon_favourite_active} alt="Followers"/>
                                                </div>
                                                <div className="broadcast-content">
                                                    <p className="font-weight-bold">{data.username}
                                                        {
                                                            data.status === "online" && <span className="online"><img src={onlineCircle} alt="Online"/></span>

                                                        }
                                                    </p>
                                                    <p className="small messages">
                                                        <a href="#"
                                                           onClick={ev => {
                                                               ev.preventDefault();
                                                               this.clickedOnIndividualMessage(data)
                                                           }}
                                                           title="Message"
                                                           id="showMessage">Message
                                                        </a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }


                            </div>
                            {
                                this.state.favouritesList && this.state.favouritesList.length === 0 &&
                                <div style={{ textAlign: 'center', marginTop: '100px'}}>
                                    <p>Sorry, no followers at the moment. Maybe go live?</p>
                                </div>
                            }
                        </div>
                    </div>
                    <MessageUser isVisible={this.state.isVisible} userData={this.state.userDataForMessage} messageAllData={this.state.messageAllData} closeMessage={this.toggleVisibilityOfMessage}/>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        account_management: state.account_management,
        broadcaster_favourites: state.broadcaster_favourites,
        broadcaster_send_message: state.broadcaster_send_message,

    };
}

export default connect(mapStateToProps, actions)(Favourites);